// extracted by mini-css-extract-plugin
export default {"title":"title--bTiP0","list":"list--xhkVe","item":"item--TWjom"};